import { render } from "./TokenSymbol.vue?vue&type=template&id=1a5c2c2d"
import script from "./TokenSymbol.vue?vue&type=script&lang=ts"
export * from "./TokenSymbol.vue?vue&type=script&lang=ts"
script.render = render

export default script